import { apiBodyMessage } from "../../utils/apiErrorMessage";

// helpdeskWorkflowService lanza `Error(data.message)` con `status`, una forma
// que apiErrorMessage no reconoce (no es axios ni throwFetchApiError) y que
// por eso caería siempre al texto genérico. Acá se rescata el mensaje del
// backend con los mismos filtros de apiBodyMessage (frases genéricas, trazas
// técnicas); el "Error 409" sintético del servicio no se muestra.
export function workflowErrorMessage(err, fallback) {
  const raw = typeof err?.message === "string" ? err.message : "";
  if (!raw || /^Error \d{3}$/.test(raw)) return fallback;
  return apiBodyMessage({ message: raw }) || fallback;
}
